import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Segment, Dimmer, Loader, Button } from 'semantic-ui-react';
import { SG_FETCH_ADMIN_PHASE_TRANSITION } from 'constants/actions';

const PhaseTransitionDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const item = useSelector((state) => state.action_phase_transition?.[id] || null);

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch({ type: SG_FETCH_ADMIN_PHASE_TRANSITION, payload: { id } });
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (item) setLoading(false);
  }, [item]);

  if (loading) {
    return (
      <Segment>
        <Dimmer active>
          <Loader>Loading phase transition...</Loader>
        </Dimmer>
      </Segment>
    );
  }

  if (!item) {
    return (<div>No phase transition found</div>);
  }

  return (
    <div>
      <Button onClick={() => navigate('../')}>Back</Button>
      <h2>{item.name || `Phase Transition ${item.id}`}</h2>
      <div><strong>From:</strong> {item.from_phase}</div>
      <div><strong>To:</strong> {item.to_phase}</div>
      <div><strong>Conditions:</strong> {item.conditions || '-'}</div>
    </div>
  );
};

export default PhaseTransitionDetails;
